import { ArrowUp, ArrowDown } from "lucide-react";

export const StatCard = ({
  icon: Icon,
  title,
  value,
  trend,
  trendDirection,
  variant = "default",
}) => {
  const variantConfig = {
    default: {
      bg: "#fff",
      iconBg: "#F3F4F6",
      iconColor: "#6B7280",
      border: "#E5E7EB",
    },
    success: {
      bg: "#fff",
      iconBg: "#D1FAE5",
      iconColor: "#10B981",
      border: "#D1FAE5",
    },
    warning: {
      bg: "#fff",
      iconBg: "#FEF3C7",
      iconColor: "#F97316",
      border: "#FED7AA",
    },
    danger: {
      bg: "#fff",
      iconBg: "#FEE2E2",
      iconColor: "#EF4444",
      border: "#FECACA",
    },
  };
  const config = variantConfig[variant];
  const styles = {
    container: {
      display: "flex",
      alignItems: "center",
      gap: "12px",
      padding: "16px 20px",
      backgroundColor: config.bg,
      borderRadius: "12px",
      border: `1px solid ${config.border}`,
      minWidth: "180px",
    },
    iconContainer: {
      width: "48px",
      height: "48px",
      borderRadius: "50%",
      backgroundColor: config.iconBg,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    icon: { width: "24px", height: "24px", color: config.iconColor },
    content: { flex: 1 },
    title: { fontSize: "13px", color: "#6B7280", marginBottom: "4px" },
    valueRow: { display: "flex", alignItems: "center", gap: "8px" },
    value: { fontSize: "24px", fontWeight: "700", color: "#111827" },
    trend: {
      fontSize: "12px",
      display: "flex",
      alignItems: "center",
      gap: "2px",
    },
    trendIcon: { width: "12px", height: "12px" },
  };
  return (
    <div style={styles.container}>
      <div style={styles.iconContainer}>
        <Icon style={styles.icon} />
      </div>
      <div style={styles.content}>
        <div style={styles.title}>{title}</div>
        <div style={styles.valueRow}>
          <span style={styles.value}>{value}</span>
          {trend && (
            <span
              style={{
                ...styles.trend,
                color: trendDirection === "up" ? "#10B981" : "#EF4444",
              }}
            >
              {trendDirection === "up" ? (
                <ArrowUp style={styles.trendIcon} />
              ) : (
                <ArrowDown style={styles.trendIcon} />
              )}
              {trend}
            </span>
          )}
        </div>
      </div>
    </div>
  );
};
